import {TrustpilotMobileBanner} from 'components/Trustpilot'
import {TrustSurveyBanner} from 'components/TrustSurvey'

import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

interface Props {
  onTrustSurveyVisibilityChange: (input: boolean) => void
}

export const SearchResultsTrustBanners = ({
  onTrustSurveyVisibilityChange
}: Props) => {
  const {isMobile, isDesktopXs} = useDeviceLayout()
  const isMobileLayout = isMobile || isDesktopXs
  const toggle = useToggle()

  if (isMobileLayout) {
    return toggle(
      'feature-trust-banners',
      <TrustpilotMobileBanner />,
      <TrustSurveyBanner onVisibilityChange={onTrustSurveyVisibilityChange} />
    )
  }

  return (
    <TrustSurveyBanner onVisibilityChange={onTrustSurveyVisibilityChange} />
  )
}
